// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2j-WT","addWidgetButton":"Header_addWidgetButton__1BlFP","dashboardTabs":"Header_dashboardTabs__3jzxL","active":"Header_active__1dv7p"};